import {useHistory} from "react-router-dom";
import ProjectUploader from "./ProjectUploader";
import useUploadProject from "../hooks/useUploadProject";

// Inline project drop area shown in the empty states of /app/run and
// /app/results, so users can upload without first navigating to the upload page.
// Once processing finishes it sends them to /app/load-project to configure/run.
export default function UploadDropzone() {
    const history = useHistory()
    const uploadProjects = useUploadProject()

    const onUploadProject = async (projects) => {
        await uploadProjects(projects)
        history.push('/app/load-project')
    }

    return <ProjectUploader onUploadProject={onUploadProject} />
}
